// extracted by mini-css-extract-plugin
export default {"profileInfoCard":"ProfileCard_profileInfoCard__CbmpU","gridBox":"ProfileCard_gridBox__LuhC+"};